// import { getFileInfoById, getSignatureByMd5 } from '@/services';
// import { message } from 'antd';
import { url as urlUtils } from 'eastedu-kit';

type timestamp = number;
export type ProgressStatus = 'ready' | 'uploading' | 'done' | 'error';
export type UploadFile = {
  createTime?: timestamp;
  downloadUrl?: string;
  extension: string;
  file?: File;
  fileId: string;
  fileName?: string;
  id?: string;
  index?: number;
  md5: string;
  name: string;
  previewUrl?: string;
  progress?: number;
  size?: number;
  status?: ProgressStatus;
  uid?: string;
  url?: string;
};

export type DownloadObject = {
  downloadUrl?: string;
  fileId?: string;
  name: string;
  md5?: string;
  extension?: string;
};

function noUrlOrMD5(file: DownloadObject) {
  return !file.downloadUrl || !file.md5;
}

// export async function get_FileMD5_And_DownloadUrl(file: DownloadObject) {
//   // 如果文件信息不全获取文件详细信息
//   if (noUrlOrMD5(file)) {
//     return await getFileInfoById(file.fileId as string);
//   }

//   // /\/(\w+)\.\w+$/.exec(file.downloadUrl)?.[1]
//   return file as { downloadUrl: string; md5: string; extension: string };
// }

/**
 *  给腾讯云点播的下载链接添加下载参数
 * @param url - 文件下载链接
 * @param fileName - 文件名称
 * @returns
 */
export function attachDownloadFileParamToUrl(url: string, fileName: string) {
  if (/[vod]\d*.myqcloud.com/.test(url)) {
    // 腾讯云点播服务，需要下载则必须添加该参数
    return urlUtils.appendQuery(url, {
      download_name: fileName,
    });
  }
  return url;
}

export const downloadFileByIframe = (url: string) => {
  if (url?.startsWith('http://')) {
    // eslint-disable-next-line no-param-reassign
    url = url.replace('http://', 'https://');
  }

  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.style.height = '0';
  iframe.src = url;
  document.body?.appendChild(iframe);
  // 5分钟之后删除（onload方法对于下载链接不起作用）
  setTimeout(() => {
    iframe.remove();
  }, 5 * 60 * 1000);
};

/**
 * 通过a标签下载文件
 * @param url - 文件下载链接
 */
export const downloadFileByALink = (url: string, fileName: string) => {
  // 触发浏览器下载
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// export async function downloadFileWithNameFromTencentOSS(
//   file: DownloadObject,
//   tip = '请稍等...',
// ) {
//   try {
//     const _file = await get_FileMD5_And_DownloadUrl(file);

//     if (/[vod]\d*.myqcloud.com/.test(_file.downloadUrl as string)) {
//       downloadFileByIframe(`${_file.downloadUrl}?download_name=${encodeURIComponent(file.name)}`);
//     } else {
//       // 到tencentOSS获取文件签名
//       const { signature } = await getSignatureByMd5(_file.md5 as string);
//       downloadFileByIframe(`${
//         _file.downloadUrl
//       }?${signature}&response-content-type=${encodeURIComponent(
//         'application/octet-stream',
//       )}&response-content-disposition=${encodeURIComponent('attachment;filename=')}
//       ${encodeURIComponent(encodeURIComponent(file.name))}`);
//     }

//     return _file;
//   } catch (error) {
//     // 获取文件签名错误直接下载
//     console.error(error);
//     file.downloadUrl && downloadFileByIframe(file.downloadUrl);
//     !file.downloadUrl && message.error('下载文件发生错误，请稍后重试！');
//   }
// }
